import React from 'react'
import cookie from 'isomorphic-cookie'

import { useModalManager, useVendor } from '~/hooks'
import type { ModalManagerProps } from '~/hooks/use-modal-manager'
import NewButton from '~/truck/new-button/NewButton'
import { cookieNames } from '~/utils/constants'

function CookiesAlert({ modalId }: ModalManagerProps) {
  const vendor = useVendor()

  const { closeModal } = useModalManager()

  function onClick() {
    cookie.save(cookieNames.ACCEPTED_COOKIES, 1, { secure: false })

    closeModal(modalId)
  }

  // FIXME: replace color (charade) and z-index (cookiesBanner)
  return (
    <div className="fixed inset-x-0 bottom-0 z-[25] flex flex-col items-center gap-6 bg-[#2d333c] p-6 lg:flex-row lg:justify-between lg:gap-12 lg:p-6">
      <div className="flex flex-col gap-2">
        <p className="text-sm font-semibold text-white lg:text-xs">Esta página web usa cookies</p>
        <p className="text-sm text-white lg:text-xs">
          Las cookies de este sitio web se usan para personalizar el contenido y analizar el tráfico. Al continuar
          usando este sitio web aceptas el uso de las cookies de acuerdo a nuestra{' '}
          <a className="underline" href={vendor.cookiesPolicyUrl} target="_blank" rel="noreferrer">
            política de cookies
          </a>
          .
        </p>
      </div>
      <div className="w-full shrink-0 lg:w-auto">
        <NewButton variant="secondary" onClick={onClick} className="min-w-32">
          Aceptar
        </NewButton>
      </div>
    </div>
  )
}

export default CookiesAlert
